import { useQuery } from "@tanstack/react-query";

import { api } from "../api/client";
import type { MoveExplanation } from "../api/types";

export default function MoveExplanationCard({ yahoo }: { yahoo: string }) {
  const q = useQuery<MoveExplanation | null>({
    queryKey: ["move", yahoo],
    queryFn: async () =>
      (await api.get<MoveExplanation | null>(`/symbols/${encodeURIComponent(yahoo)}/move`)).data,
    enabled: !!yahoo,
    staleTime: 60_000,
  });

  if (!q.data) return null;
  const { day, change_pct, summary } = q.data;
  const dir = change_pct >= 0 ? "▲" : "▼";
  const cls = change_pct >= 0 ? "text-emerald-400" : "text-rose-400";

  return (
    <section className="rounded-2xl border border-amber-500/20 bg-amber-500/5 p-4">
      <div className="mb-2 flex items-baseline justify-between">
        <h3 className="text-sm font-medium text-amber-200">Why did it move?</h3>
        <span className={`text-xs tabular-nums ${cls}`}>
          {dir} {Math.abs(change_pct).toFixed(2)}% on {day}
        </span>
      </div>
      <div className="whitespace-pre-line text-sm leading-relaxed text-slate-200">{summary}</div>
    </section>
  );
}
